import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../components/User/Header/Header";
import Footer from "../../../components/User/Footer/Footer";
import HomeBanner from "../../../images/background/homeBanner.jpg";

function Faqs() {
  useEffect(()=>{
  window.scrollTo(0,0)
    },[])
  const [activeIndex, setActiveIndex] = useState(null);
  const faqs = [
    {
      question: "Why Carry My Baggage?",
      answer: "Carrymybaggage offers convenient, reliable and cost-effective baggage transfer services, worldwide."
    },
    {
      question: "How do CarryMyBaggage rates compare to charges on excess baggage?",
      answer: `
        Handling fee - will be charged at point of destination for all shipments. This differs from airport to airport and from airline to airline. 
        There is no way of knowing at the point of booking which airline will best suit your requirements, and it is thus impossible to accurately predict 
        the amount for these charges. The airline handling agent advisor at destination can give you an indication, and in all cases, these charges are minimal.
  
        Storage - is charged, with immediate effect, once your goods get to their destination. It is therefore imperative that the goods are collected 
        on the day of arrival, to avoid incurring additional storage charges. There is no charge for storage whilst your shipment is with CarryMyBaggage, awaiting shipment.
  
        Customs - if the goods are personal effects, that exceeded your weight allowance, we do not foresee any customs charges. However, many items have 
        customs restrictions or require specific documentation before they can be shipped. You should consult with the CarryMyBaggage advisor for details.`
    },
    {
      question: "Is doorstep delivery available?",
      answer: `
        Yes - Delivery to the doorstep is available to some destinations but is expensive. Usually, you have to go to the airport, so why pay more if you can 
        clear customs yourself? Additional charges apply for delivery to the door, so check with CarryMyBaggage. For delivery to your doorstep, we require 
        local customs forms completed, a complete packing list, a copy of passport and copy of student ID (if you are a student).`
    },
    {
      question: "Does my baggage travel on the same aircraft I am travelling on?",
      answer: "It’s not necessarily the case, but in case you wish your baggage to travel along with you on same aircraft, we can make prior arrangements for the same."
    },
    {
      question: "How do I find my baggage at the destination?",
      answer: `
        Once your baggage is in care of CarryMy Baggage, we convey to you the Airline your baggage is travelling on, the airwaybill number - an eleven-digit number (tracking number), 
        the IATA airline two letter code, the estimated arrival date and the phone number of the airline at the airport of arrival. Once CarryMyBaggage has picked up your baggage, 
        please ensure that you ring our office before you leave India, as it is very hard to find your baggage if you do not know the above details. Indian security regulations 
        do not allow CarryMy Baggage to give these details before your baggage is in our care.`
    },
    {
      question: "Will I be contacted at the destination via email/IM/phone call?",
      answer: `
        Yes - Once your baggage has arrived at its destination. You are only allowed a fixed number of hours for free storage upon arrival. To avoid storage charges, 
        you must go to the airport as soon as you’ve been notified of the arrival of your luggage.`
    },
    {
      question: "What about duties, GST, VAT, and sales tax?",
      answer: "Duties, sales tax, GST, and VAT all vary from country to country, and usually if you have owned your personal effects for more than 12 months, no taxes are payable. You may be asked for receipts to prove ownership and date of purchase."
    },
    {
      question: "Can I bring my baggage to Carry My Baggage?",
      answer: "We are happy for you to bring in your baggage to our offices or just come and check us out. Our offices are open from 9am to 5pm (IST), Monday to Friday."
    },
    {
      question: "How much weight should I pack per box/bag?",
      answer: "For Health and Safety reasons we suggest that no more than 30 kilograms be packed per item."
    },
    {
      question: "Do I seal my bags, boxes, or cartons?",
      answer: `
        Yes - We do not need to know or see what is inside. All baggage is subject to x-ray examination and search if necessary. CarryMyBaggage or the International Airline will not open 
        your baggage unless you are present with it. However, customs in any airport reserve the right to inspect your baggage without you being physically present. 
        CarryMyBaggage security seals all baggage in our offices prior to dispatch overseas.`
    },
    {
      question: "Should I number the baggage?",
      answer: "Yes - for more than one piece of luggage you should number each piece, in case customs want to inspect them at the destination."
    },
    {
      question: "Are there any charges at the destination?",
      answer: `
        For door-to-door consignments there may be additional charges at destination. Some countries have government charges for quarantine clearance; others have examination and X-ray fees, etc. 
        All duties and taxes are excluded from the quotation you receive from us. Our door-to-door charges include the pre-payment of destination port/airport unloading, 
        normal customs clearance and delivery charges to your residence overseas. If you send your baggage to port or airport only, you will be responsible for local unloading, 
        and dock/port or airport charges. These will vary according to destination. For further information, please contact us.`
    },
    {
      question: "What documents do I need?",
      answer: `
        You will have to complete a packing list or inventory list, and provide a copy of the photo page of your passport. Additional documents may be required before your shipment can leave 
        the country. Please check the documentation section on our website or contact us for more information. All relevant documentation must be received before your shipment is ready for transit.`
    },
    {
      question: "Insurance",
      answer: `
        Despite of all the precautions and safety, your baggage and personal belongings can be stolen, lost or damaged due to unfortunate circumstances. Baggage insurance is important as airlines 
        can only provide limited protection for your baggage. With insurance of your baggage, you get the best protection of your baggage from the time of departure till the time of arrival on the destination. 
        We recommend baggage insurance to our clients as this protects their baggage against mishaps and unfortunate events. For enquiry on our insurance policy kindly contact our customer support service.`
    }
  ];
    
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <Header />
    <section
          class="call-to-action-one sp-four"
          style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div class="container">
            <div class="sec-title-one white text-center">
              {/* <h5>Keep Runing</h5> */}
              <h2>Frequently Ask Questions</h2>
            </div>
            {/* <div class="text mt-20 mb-50">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est <br /> laborum.sed ut
              perspiciatis unde.
            </div>
            <div class="link-btn">
              <a href="#" class="theme-btn btn-style-two">
                Get Appointment
              </a>
            </div> */}
          </div>
        </section>
      <section className="faq-section sp-eight">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-md-12 col-sm-12">
              <ul className="accordion-box">
                {faqs.map((obj, index) => (
                  <li className="accordion block" key={index}>
                    <div className="acc-btn" onClick={() => toggleAccordion(index)}>
                      <div className="icon-outer">
                        {activeIndex===index?
                        <span className="icon icon_minus fa fa-minus"></span>
                        :
                        <span  className="icon icon_plus fa fa-plus"></span>
                        }
                      </div>
                      {obj.question}
                    </div>
                    <div
                    style={{borderTop:'2px solid rgb(221 224 227)'}}
                      className={`acc-content ${activeIndex === index ? "current" : ""}`}
                    >
                      <div className="content">
                        <div className="text">
                          <p className='text-justify' style={{marginBottom: '20px',lineHeight: '26px',fontSize: '16px',color:'#474747',
fontWeight: '400'}}>
                           {obj.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-xl-4 col-md-12 col-sm-12">
              <div className="ask-question-area">
                <div className="default-form-area">
                  <div className="sec-title-two mb-30">
                    <h5>Ask Question?</h5>
                  </div>
                  <form
                    id="contact-form"
                    name="contact_form"
                    className="contact-form style-two"
                    action="inc/sendmail.php"
                    method="post"
                  >
                    <div className="form-group">
                      <input
                        type="text"
                        name="form_name"
                        className="form-control"
                        value=""
                        placeholder="Your Name"
                        required=""
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        name="form_email"
                        className="form-control required email"
                        value=""
                        placeholder="Your Email"
                        required=""
                      />
                    </div>
                    <div className="form-group">
                      <textarea
                        name="form_message"
                        className="form-control textarea required"
                        placeholder="Your Message"
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <input
                        id="form_botcheck"
                        name="form_botcheck"
                        className="form-control"
                        type="hidden"
                        value=""
                      />
                      <button
                        className="theme-btn btn-style-six"
                        type="submit"
                        data-loading-text="Please wait..."
                      >
                        Get Answer
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Faqs;
